import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgExecutiveLeaving(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8a2 2 0 11-4 0 2 2 0 014 0zm1 0a3 3 0 11-6 0 3 3 0 016 0zm-7 8.786c0-1.306.704-2.472 1.785-3.154l1.347 2.356a1 1 0 001.736 0l1.347-2.356c1.08.682 1.785 1.848 1.785 3.154V18H4v-1.214zm4-1.294l-1.306-2.286A4.204 4.204 0 018 13c.459 0 .898.073 1.307.206L8 15.492zM3.5 19h9a.5.5 0 00.5-.5v-1.714C13 14.12 10.738 12 8 12s-5 2.12-5 4.786V18.5a.5.5 0 00.5.5zM15 6h3.5l-1.871.749a1 1 0 00-.629.928V18h-1V6zm2.5 8H17v5.523l3-1.2V6.477l-3 1.2V13h.5a.5.5 0 010 1zM16 19h-1a1 1 0 01-1-1V6a1 1 0 011-1h5a1 1 0 011 1v12.323a1 1 0 01-.629.928l-3 1.2A1 1 0 0116 19.523V19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveLeaving);

var ExecutiveLeavingOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ExecutiveLeavingOutline as default };
